import { useField } from "formik";
import { cn } from "utils/helpers";
import { Location } from "components/FormInputs/Location";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";

export const AddressFinderQuestionnaire = ({
	className,
	question,
	required,
	fieldValue,
	...props
}) => {
	const [, { error }] = useField(props);

	return (
		<div className={cn(className)}>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
				description={props?.rfqSubmission ? "Address selection" : null}
			/>
			<div>
				<Location
					errorBottom={"-3px"}
					rfq
					className="relative my-4"
					required={required}
					rfqIcon="address-finder-icon"
					applyValue
					isErrorValue={error && props?.touchedField}
					{...props}
					inputTestId={`input-${props?.name}`}
					dropdownTestId={`location_auto_complete`}
				/>
			</div>
		</div>
	);
};
